import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import toastr from 'toastr';



export class Login extends Component {

    constructor(props) {
      super(props);
      toastr.options.closeDuration = 200;
    }

    moveAway = (e) => {
        e.preventDefault();
        this.props.history.push('/dashboard');
    }

    render() {
        return(
          <div className="middle-box text-center loginscreen animated fadeInDown">
                  <div>
                      <div>
                          <h1 className="logo-name">NXXT</h1>
                      </div>
                      <h3>Welcome to NXXT</h3>
                      <p>MOVE FREIGHT WITH EASE

                      </p>
                      <p>Login in. To see it in action.</p>
                      <form className="m-t" role="form" action="index.html">
                          <div className="form-group">
                              <input type="email" className="form-control" placeholder="Username" required="" />
                          </div>
                          <div className="form-group">
                              <input type="password" className="form-control" placeholder="Password" required="" />
                          </div>
                          <button className="btn btn-danger full-width" onClick={this.moveAway}>Login</button>

                          <a href="#"><small>Forgot password?</small></a>
                          <p className="text-muted text-center"><small>Do not have an account?</small></p>
                          <a className="btn btn-sm btn-white btn-block">Create an account</a>
                      </form>
                      <p className="m-t"> <small>all rights reserved</small> </p>
                  </div>
              </div>


            );
    }
}
;



// WEBPACK FOOTER //
// ./src/pages/Login.js